<template>
  <NonFullPartnerRequestedOfferCardContainer
    v-bind="$attrs"
    :offer="offer"
    :product-label="productLabel"
  >
    <template #modal>
      <FatalErrorDialog
        :error-reason="cptdOfferErrorReason"
        :offer="offer"
        :display="displayErrorModal"
        @close="displayErrorModal = false"
      />
    </template>
  </NonFullPartnerRequestedOfferCardContainer>
</template>
<script>
import { OfferErrorReason } from '@/data/common'
import NonFullPartnerRequestedOfferCardContainer from '@/containers/loans/NonFullPartnerRequestedOfferCardContainer.vue'
import FatalErrorDialog from '@/containers/loans/FatalErrorDialog.vue'
export default {
  name: 'FatalErrorOfferCardContainer',
  components: {
    NonFullPartnerRequestedOfferCardContainer,
    FatalErrorDialog,
  },
  props: {
    offer: { type: Object, required: true },
    productLabel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      displayErrorModal: false,
    }
  },
  computed: {
    cptdOfferErrorReason() {
      switch (this.offer?.error_reason) {
        case OfferErrorReason.INVALID_BANK_DIGIT:
          return 'O dígito do banco é invalido. Tente simular novamente'
        default:
          return 'Não foi possível finalizar a sua solicitação, simule novamente.'
      }
    },
  },
}
</script>
<style lang="scss"></style>
